module.exports = __webpack_public_path__ + "img/b.cd635dd5.jpg";